module.exports = __webpack_public_path__ + "static/media/fabXsSandstorm.1f656865.jpg";